module.exports = __webpack_public_path__ + "img/daily-billing-icon.173f213b.svg";